require("./saved-items.scss");

(function ($, savedItemsData) {
    const apiUrl = savedItemsData.apiUrl;
    const get = (url) => fetch(url,
        {
            method: "GET",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" }
        });

    const post = (url, data) => fetch(url,
        {
            method: "POST",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" },
            body: data ? JSON.stringify(data) : ""
        });

    const del = (url) => fetch(url,
        {
            method: "DELETE",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" }
        });

    const loadStatus = () => {
        let ids = $(".save-item[data-item-id]").map((i, elm) => $(elm).data("itemId"));
        ids = $.makeArray(ids).join(",");

        if (ids.length > 0) {
            const url = `${apiUrl}?ids=${ids}&random=${new Date().getTime()}`;
            get(url)
                .then(x => {
                    x.json().then(y => {
                        y.filter(e => e.saved).forEach((el) => {
                            $(`.save-item[data-item-id=${el.id}]`).addClass("saved").data("webmClickValue", "unsave-item");
                        });
                    });
                });
        }
    };

    const loadComponents = () => {
        $("#save_item_buttons").children().each(function() {
            const elm = $(this);
            $(elm.data("target")).append(elm);
        });
    };

    $(() => {
        loadComponents();
        loadStatus();

        $(".save-item[data-item-id]").on("click", function (e) {
            e.preventDefault();

            if (!savedItemsData.isAuthenticated) {
                $.colorbox({ inline: true, href: "#saved_items_requires_authentication_dialog", transition: "none" });
            } else {
                const elm = $(this);
                const itemId = elm.data("itemId");
                const url = `${apiUrl}${itemId}`;

                if (elm.hasClass("saved")) {
                    elm.removeClass("saved");
                    del(url)
                        .then(x => {
                            if (x.ok) {
                                elm.data("webmClickValue", "save-item");
                            } else {
                                elm.addClass("saved");
                            }
                        });
                } else {
                    elm.addClass("saved");
                    post(url)
                        .then(x => {
                            if (x.ok) {
                                elm.data("webmClickValue", "unsave-item");
                            } else {
                                elm.removeClass("saved");
                            }
                        });
                }
            }
        });
    });

})(jQuery, window.saved_items_data);